import { render, staticRenderFns } from "./MobileIdentityHeader.vue?vue&type=template&id=15ed8dea&lang=html&"
import script from "./MobileIdentityHeader.vue?vue&type=script&lang=js&"
export * from "./MobileIdentityHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15ed8dea')) {
      api.createRecord('15ed8dea', component.options)
    } else {
      api.reload('15ed8dea', component.options)
    }
    module.hot.accept("./MobileIdentityHeader.vue?vue&type=template&id=15ed8dea&lang=html&", function () {
      api.rerender('15ed8dea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/menus/MobileMenuComponents/MobileIdentityHeader.vue"
export default component.exports